import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ToolTipIcon } from './ProjectIcons';

interface TooltipProps {
    description: string | React.ReactNode;
    position?: 'top' | 'bottom' | 'bottomleft' | 'left' | 'right';
    width?: string;
    ariaLabel?: string;
}

export const Tooltip: React.FC<TooltipProps> = ({ description, position = 'top', width = 'w-40', ariaLabel }) => {
    const { t } = useTranslation();
    const [showTooltip, setShowTooltip] = useState(false);

    const getTooltipPositionClass = () => {
        switch (position) {
            case 'top':
                return 'bottom-full left-1/2 transform -translate-x-1/2 mb-2';
            case 'bottom':
                return 'top-full right-0 transform mt-2';
            case 'bottomleft':
                return 'top-full left-0 transform mt-2';
            case 'left':
                return 'right-full top-0 transform -translate-y-0 mr-2';
            case 'right':
                return 'left-full top-0 transform -translate-y-0 ml-2';
            default:
                return '';
        }
    };

    return (
        <div className="mb-1.5 relative inline-block">
            <button
                type="button"
                className="cursor-pointer p-0 outline-none focus:ring-2 focus:ring-gray-lines rounded-full flex items-center justify-center w-3.5 h-3.5"
                onMouseEnter={() => setShowTooltip(true)}
                onMouseLeave={() => setShowTooltip(false)}
                onFocus={() => setShowTooltip(true)}
                onBlur={() => setShowTooltip(false)}
                aria-label={ariaLabel ?? (typeof description === 'string' ? description : t('More information'))}
            >
                <span className="inline-flex items-center justify-center w-4 h-4 rounded-full -translate-y-0.5">
                    <ToolTipIcon />
                </span>
            </button>
            {showTooltip && (
                <div className={`${width} absolute ${getTooltipPositionClass()} bg-white border border-gray-lines p-2 rounded shadow-lg z-10 text-secondary-gray`}>
                    {description}
                </div>
            )}
        </div>
    );
};